// GENERATED BY ./src/scripts/generateComponents.ts
// DO NOT EDIT IT MANUALLY

import React from "react";

import { iconStatausdtb } from "../../../icons/mono/build/icon-statausdtb.icon";
import { IconComponentBaseProps } from "../../../utils";
import { Image } from "../../Base/Image";

const StatausdtbIcon = (props: IconComponentBaseProps) => {
  return <Image svgCode={iconStatausdtb.data} {...props} />;
};

if (process.env.NODE_ENV !== 'production') {
  StatausdtbIcon.displayName = 'StatausdtbIcon';
}

export default StatausdtbIcon;